import { render, staticRenderFns } from "./insecure.vue?vue&type=template&id=97a5a460&"
import script from "./insecure.vue?vue&type=script&lang=ts&"
export * from "./insecure.vue?vue&type=script&lang=ts&"
import style0 from "./insecure.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports